module.exports = __webpack_public_path__ + "BradescoSans-Regular.6f0dfef41ab68969b5af.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/BradescoSans/BradescoSans-Regular.woff2
// module id = ../../../../../src/assets/fonts/BradescoSans/BradescoSans-Regular.woff2
// module chunks = main